import { render } from "./ViewData.vue?vue&type=template&id=53186910&scoped=true&ts=true"
import script from "./ViewData.vue?vue&type=script&lang=ts"
export * from "./ViewData.vue?vue&type=script&lang=ts"

import "./ViewData.vue?vue&type=style&index=0&id=53186910&lang=scss&scoped=true"

import exportComponent from "/Users/andrski/developing/web/client_shina_m1/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53186910"]])

export default __exports__